export const dateToday = new Date().toISOString().substring(0, 10)

export const currentMonth = () => {
  const date = new Date()

  const month = date.getMonth() + 1

  switch (month) {
    case 1:
      return 'janeiro'
    case 2:
      return 'fevereiro'
    case 3:
      return 'março'
    case 4:
      return 'abril'
    case 5:
      return 'maio'
    case 6:
      return 'junho'
    case 7:
      return 'julho'
    case 8:
      return 'agosto'
    case 9:
      return 'setembro'
    case 10:
      return 'outubro'
    case 11:
      return 'novembro'
    case 12:
      return 'dezembro'
  }
}

export const formatDate = (date: string): string => {
  const dateFormatted = new Date(date)
  const day =
    dateFormatted.getDate() + 1 > 9
      ? dateFormatted.getDate() + 1
      : `0${dateFormatted.getDate() + 1}`

  const month =
    dateFormatted.getMonth() + 1 > 9
      ? dateFormatted.getMonth() + 1
      : `0${dateFormatted.getMonth() + 1}`

  const year = dateFormatted.getFullYear()

  if (date === `${year + 1}-01-01`) {
    return `01/01/${year + 1}`
  } else if (date === `${year}-02-01`) {
    return `01/02/${year}`
  } else if (date === `${year}-03-01`) {
    return `01/03/${year}`
  } else if (date === `${year}-04-01`) {
    return `01/04/${year}`
  } else if (date === `${year}-05-01`) {
    return `01/05/${year}`
  } else if (date === `${year}-06-01`) {
    return `01/06/${year}`
  } else if (date === `${year}-07-01`) {
    return `01/07/${year}`
  } else if (date === `${year}-08-01`) {
    return `01/08/${year}`
  } else if (date === `${year}-09-01`) {
    return `01/09/${year}`
  } else if (date === `${year}-10-01`) {
    return `01/10/${year}`
  } else if (date === `${year}-11-01`) {
    return `01/11/${year}`
  } else if (date === `${year}-12-01`) {
    return `01/12/${year}`
  }

  return `${day}/${month}/${year}`
}
